import { Loader as BaseLoader } from '@/components/Loader';

import s from './Loader.module.scss';

/** Спиннер появляется с задержкой: на быстрой загрузке он не мигает */
const Loader = () => (
  <div className={s.loader}>
    <BaseLoader />
  </div>
);

export { Loader };
